<div class="create-custom-tag-container">
	<h2 class="create-custom-tag-title">
		{{ Loc(LocalizedTextIds.CreateCustomTagNoTags) }}
	</h2>
	<p class="create-custom-tag-text">
		<localized-text-snippet
			text="{{
				Loc(LocalizedTextIds.CreateCustomTagWouldYouLikeToAdd, tagName)
			}}"
		></localized-text-snippet>
	</p>
	<button class="create-custom-tag-button" (click)="createCustomTag()">
		{{ actionButtonText }}
	</button>
</div>
